import i18n from '@/locales'
export default {
  index: 5,
  meta: {
    label: i18n.t('winrd.menu'),
    icon: 'res-vminstance',
    catalog: 'rdp',
  },
  menus: [
    {
      meta: {
        label: i18n.t('winrd.menu'),
      },
      submenus: [
        {
          path: '/rdp/desktop',
          meta: {
            label: i18n.t('winrd.desktop'),
            icon: 'res-systemuser',
            permission: 'rdp_resource_list',
          },
          component: () => import('@WinRD/views/myspace/index.vue'),
        },
      ],
    },
    {
      meta: {
        label: i18n.t('winrd.resource_mgmt'),
      },
      submenus: [
        {
          path: '/rdp/accounts',
          meta: {
            label: i18n.t('winrd.account_mgmt'),
            icon: 'res-group',
            permission: 'rdp_management_update',
          },
          component: () => import('@WinRD/views/accounts/index.vue'),
        },
        {
          path: '/rdp/nodes',
          meta: {
            label: i18n.t('winrd.node_mgmt'),
            icon: 'res-instancegroup',
            permission: 'rdp_management_update',
          },
          component: () => import('@WinRD/views/nodes/index.vue'),
        },
      ],
    },
  ],
}
